import { BOX_ID_HEADER } from '@nest-react-monorepo/contracts';
import { ApiRequestError } from './api-error.js';

/**
 * The box chosen in اختيار الصندوق (currency.md section 3.1.4). The API
 * client sends it on every call, so the box balance, the context, the photo
 * upload, the tablets and the cash entries all work on that box.
 */
let chosenBoxId: string | null = null;

export function setChosenBoxId(id: string | null): void {
  chosenBoxId = id;
}

export function chosenBoxHeader(): Record<string, string> {
  return chosenBoxId ? { [BOX_ID_HEADER]: chosenBoxId } : {};
}

let onBoxUnavailable: (() => void) | null = null;

/** The box gate's reaction to an unavailable box; null to stop listening. */
export function onBoxUnavailableChange(listener: (() => void) | null): void {
  onBoxUnavailable = listener;
}

/**
 * Called for every failed query and mutation: a BOX_UNAVAILABLE answer (the
 * box was deactivated or the user is no longer one of its employees) clears
 * the kept box and returns to اختيار الصندوق, or to the no-box message.
 */
export function handleBoxUnavailable(error: unknown): void {
  if (error instanceof ApiRequestError && error.code === 'BOX_UNAVAILABLE') onBoxUnavailable?.();
}
